import { render } from "./Listar.vue?vue&type=template&id=c3776036&scoped=true"
import script from "./Listar.vue?vue&type=script&lang=js"
export * from "./Listar.vue?vue&type=script&lang=js"

import "./Listar.vue?vue&type=style&index=0&id=c3776036&scoped=true&lang=css"

import exportComponent from "/var/www/html/bibliofides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3776036"]])

export default __exports__